module.exports = "/_next/static/images/button-de2e2a506051f52674d856b120efe3d0.png";